$(document).ready(function()
{



    if ($('.sortable-table').length)
    {
        $('.sortable-table').DataTable(
        {
            "searching": true,
            "info": true,
            "paging": false,
            "language": {
                search: '<i class="fa fa-filter" aria-hidden="true"></i><span class="show-for-sr">Filter</span>',
                searchPlaceholder: 'Filter table'
            },
            "order": [[ 0, "asc" ]],
            
        });
        
        $("#tableSearcher").html($(".dataTables_filter"));  

    }


    if ($('.sortable-table-none').length)
    {
        $('.sortable-table-none').DataTable(
        {
            "searching": false,
            "info": false,
            "paging": false,
            "order": [[ 0, "asc" ]]
        });
    
    } 


    if ($('.sortable-table-players').length)
    {

        var the_table = $('.sortable-table-players').DataTable(
        {
            searching: false,
            info: false,
            paging: false,
            rowReorder: {
                selector: 'tr',
                update: true
            },
            order: [[0, "asc"]],
            columnDefs: [
                {
                    targets: 0,
                    visible: true
                }
            ]

        });

        the_table.on( 'row-reorder', function ( e, diff, edit ) 
        {

            setTimeout(function () 
            {
                alert ("order8");
                var data = the_table.data().toArray();
                var data_final = [];
                $.each( data, function( index, value ) 
                {
                    const person = 
                    {
                        position: value[0],
                        first_name: value[1],
                        last_name: value[2],
                        status: value[3],
                    };

                     data_final.push(person);
                });

                data_final.sort((a,b) => a.position - b.position);


                console.log(data_final);
            }, 100);
            
        });



      
    } 

});